import { createApp } from 'vue';
import PopOutPanelHost from '@/components/PopOutPanelHost.vue';
import { attachVueErrorHandler } from '@/shared/sentry.js';

// The pop-out panel stack is a site-wide facility, not the property of any one widget,
// so it gets its own app root rather than being rendered inside the basket button or
// the search page. Any component anywhere can then call openPanel() from
// shared/panelStack.js and have it appear, whichever app root it lives in.
//
// Must mount exactly once per page - the host renders every entry in the stack, so two
// hosts means every panel drawn twice.
const el = document.getElementById('pop-out-panels');

if (el) {
    const app = createApp(PopOutPanelHost);
    attachVueErrorHandler(app);
    app.mount(el);
}
